import React, { useMemo } from "react";
import "./DownloadsHero.css";

const tryParseJsonObject = (str) => {
  const t = String(str || "").trim();
  if (!t.startsWith("{") || !t.endsWith("}")) return null;
  try {
    const o = JSON.parse(t);
    return o && typeof o === "object" && !Array.isArray(o) ? o : null;
  } catch {
    return null;
  }
};

const coalesceHeroPayload = (raw) => {
  if (raw == null) return null;
  if (typeof raw === "string") {
    return coalesceHeroPayload(tryParseJsonObject(raw) || {});
  }
  if (typeof raw !== "object") return null;

  const mergeHeroWrapper = (node, into) => {
    const wrap = node?.hero ?? node?.Hero;
    if (!wrap || typeof wrap !== "object") return into;
    if (wrap.data && typeof wrap.data === "object" && !Array.isArray(wrap.data)) {
      return { ...into, ...wrap.data };
    }
    return { ...into, ...wrap };
  };

  let base = { ...raw };
  base = mergeHeroWrapper(raw, base);
  if (raw.data && typeof raw.data === "object" && !Array.isArray(raw.data)) {
    base = { ...base, ...raw.data };
    base = mergeHeroWrapper(raw.data, base);
  }
  if (typeof raw.value === "string") {
    const parsed = tryParseJsonObject(raw.value);
    if (parsed) base = { ...base, ...parsed };
  } else if (raw.value && typeof raw.value === "object" && !Array.isArray(raw.value)) {
    base = { ...base, ...raw.value };
  }
  return mergeHeroWrapper(base, base);
};

const pickString = (...candidates) => {
  for (const c of candidates) {
    if (typeof c === "string" && c.trim()) return c.trim();
  }
  return "";
};

const hasMeaningfulHeroPayload = (p) => {
  if (!p || typeof p !== "object") return false;
  return Boolean(
    pickString(
      p.tag,
      p.sectionTag,
      p.titleLine1,
      p.titleLine2,
      p.title,
      p.heading,
      p.description,
      p.body,
      p.text,
      p.summary
    )
  );
};

const DownloadsHero = ({ content }) => {
  const view = useMemo(() => {
    const payload = coalesceHeroPayload(content);
    if (!hasMeaningfulHeroPayload(payload) || !payload) return null;
    return {
      tag: pickString(payload.tag, payload.sectionTag),
      titleLine1: pickString(payload.titleLine1),
      titleLine2: pickString(payload.titleLine2),
      titleSingle: pickString(payload.title, payload.heading),
      description: pickString(payload.description, payload.body, payload.text, payload.summary),
    };
  }, [content]);

  if (!view) return null;

  const titleBlock =
    view.titleLine1 || view.titleLine2 ? (
      <h1>
        {view.titleLine1}
        {view.titleLine2 ? (
          <>
            {view.titleLine1 ? <br /> : null}
            <span>{view.titleLine2}</span>
          </>
        ) : null}
      </h1>
    ) : view.titleSingle ? (
      <h1>{view.titleSingle}</h1>
    ) : null;

  return (
    <section className="downloadsHero">
      <div className="downloadsHero-inner">
        {view.tag ? <span className="downloadsHero-tag">{view.tag}</span> : null}
        {titleBlock}
        {view.description ? <p>{view.description}</p> : null}
      </div>
    </section>
  );
};

export default DownloadsHero;
